/**
 * Maps full location names to their standardized 2/3-letter codes.
 */
const locationCodeMap: Record<string, string> = {
	Virginia: 'VA',
	Michigan: 'MI',
	Arizona: 'AZ',
	California: 'CA',
	Amsterdam: 'AMS',
	London: 'LON',
	Sydney: 'SYD',
};

/**
 * Returns the standardized 2/3-letter location code for a given location name.
 * If no mapping exists, returns the original location name.
 */
export const getLocationCode = (location: string): string | undefined => {
	return locationCodeMap[location] ?? undefined;
};

export default locationCodeMap;
